<template>
    <div>
        <Button
            @click="show = true"
            color="danger-outline"
            size="small"
            iconName="trash"
            class="w-full"
        >
            Delete
        </Button>

        <ModalConfirmation
            :show="show"
            :action="submit"
            color="danger"
            title="Are you sure you want to delete this Integration?"
            actionText="Yes, delete"
            :actionProcessing="apiFormRef?.loading.valueOf()"
            @close="show = false"
        >
            <template
                #content
                class="text-gray-500 text-center"
            >
                <div class="text-gray-500 text-center">
                    This action is irreversible.
                </div>
            </template>
        </ModalConfirmation>

        <ApiForm
            :url="urlFactory.makeIntegrationDeleteUrl(integration.id)"
            method="POST"
            :disableCatch="false"
            ref="apiFormRef"
        />
    </div>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import Integration from '@/App/Integration/Entity/Integration'
    import Button from '@/Shared/Component/Button.vue'
    import ModalConfirmation from '@/Shared/Component/ModalConfirmation.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'

    const emits = defineEmits(['onSuccess'])
    const urlFactory = new UrlFactory()

    const props = defineProps({
        integration: {
            type: Object as PropType<Integration>,
            required: true,
        },
    })

    const show = ref<boolean>(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value
            ?.submit()
            ?.then(() => {
                emits('onSuccess')
                show.value = false
            })
            ?.catch(() => {
                show.value = false
            })
    }
</script>
